import http from '@/api/http'
/**
 * 授权接口加前缀：authSystem，
 * 用户接口加前缀：userSystem,
 * 认证接口加前缀：verifySystem,
 * 日志接口加前缀：logSystem,
 * 审核接口加前缀：spaceAdminSystem
 */
export default {
    //上传文件
    postFile(cb, form) {
        http.postFile('/api/fileSystem/file/upload', cb, form)
    },
    //获取pdf
    getReport(cb, form) {
        http.get('/api/spaceAdminSystem/space/org/report', cb, form)
    },
    //问卷调查审核
    postId(cb, form) {
        http.post('/api/spaceAdminSystem/spaceAdmin/questionnaire/report', cb, form)
    },
}